module.exports = __webpack_public_path__ + "img/radar_ok.3146d59a.svg";